export default __webpack_public_path__ + "static/media/instagram.6bdd3f62.svg";